<script setup lang="ts">
import { ref } from '@vue/composition-api'

export default {
  props: {
    width: Number,
    title: String,
    message: String,
    yesText: String,
    noText: String
  },
  setup (props, { emit }) {
    const active = ref(false)

    function yes () {
      active.value = false
      emit('yes')
    }
    function no () {
      active.value = false
      emit('no')
    }

    return {
      active,
      yes,
      no
    }
  }
}
</script>
<template>
  <v-dialog v-model="active" :width="width || 400">
    <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
      <slot :name="scopedSlotName" v-bind="slotData"></slot>
    </template>
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName"></slot>
    </template>
    <v-card>
      <v-card-title>{{ title || 'Please Confirm' }}</v-card-title>
      <v-card-text v-html="message || 'Please confirm you would like to proceeed'"></v-card-text>
      <v-card-actions>
        <v-btn text @click="yes()">{{ yesText || 'Yes' }}</v-btn>
        <v-spacer />
        <v-btn text @click="no()">{{ noText || 'No' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
